




































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import UserModel from '@/_models/UserModel'

// Component
import SearchCategory from '@/components/user/partials/SearchCategory.vue'
import SearchCard from '@/components/user/partials/SearchCard.vue'
import SearchBeacon from '@/components/user/partials/SearchBeacon.vue'
import UserType from '@/components/shared/UserType.vue'
import { cloneDeep } from 'lodash'

@Component({
  components: {
    SearchCategory,
    SearchCard,
    SearchBeacon,
    UserType,
  },
  computed: {},
})
export default class UserUpsertForm extends Vue {
  @Prop() dataSelected!: UserModel
  @Prop({ default: false }) isNew!: boolean

  get selected() {
    return this.dataSelected
  }

  set selected(value: UserModel) {
    this.$emit('update:dataSelected', value)
  }

  activeTabCardBeacon: number = 0
  isSearchCatActive: boolean = false
  isSearchCardActive: boolean = false
  isSearchBeaconActive: boolean = false

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }

  get selectedMajorMinor(): string {
    return [this.selected.major, this.selected.minor].join('/')
  }

  get searchBeaconType(): any {
    return 'carried'
  }

  get selectedCat(): object {
    return {
      _id: this.selected.category_id,
      name: this.selected.category_name,
    }
  }

  get selectedCard(): object {
    return {
      _id: this.selected.card_id,
      san_id: this.selected.san_id,
    }
  }

  get selectedBeacon(): object {
    return {
      _id: this.selected.beacon_id,
      major: this.selected.major,
      minor: this.selected.minor,
    }
  }

  async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then((result) => {
      if (!result) {
        return false
      }
      if (this.activeTabCardBeacon === 0) {
        this.selected.beacon_id = ''
      } else {
        this.selected.card_id = ''
      }

      const storePath = this.isNew ? 'users/addOne' : 'users/updateOne'
      const successMessage = this.isNew
        ? 'messages.save_success'
        : 'messages.update_success'

      this.$store.dispatch(storePath, this.selected).then(() => {
        this.closeModal()
        this.$buefy.toast.open(this.$t(successMessage) as string)
      })
    })
  }

  handleSelectedCatDone(data): void {
    this.selected.category_id = data._id
    this.selected.category_name = data.name
    this.isSearchCatActive = false
  }

  handleSelectedCardDone(data): void {
    this.selected = {
      ...cloneDeep(this.selected),
      beacon_id: '',
      major: '',
      minor: '',
      card_id: data._id,
      san_id: data.san_id,
    }

    this.isSearchCardActive = false
  }

  handleSelectedBeaconDone(data): void {
    this.selected = {
      ...cloneDeep(this.selected),
      beacon_id: data._id,
      major: data.major,
      minor: data.minor,
      card_id: '',
      san_id: '',
    }

    this.isSearchBeaconActive = false
  }

  closeModal() {
    this.$emit('closeModal', false)
  }

  created() {
    this.activeTabCardBeacon = this.selected.beacon_id ? 1 : 0
  }
}
